import { clampForSpeech, shouldSpeakAnswers } from "@/lib/training/trainingPanelLogic";
import { speak } from "@/lib/speech/speak";

export function speakRoleplayCustomerLine(text: string) {
  if (!shouldSpeakAnswers()) return;
  const toSay = clampForSpeech(text);
  if (!toSay) return;
  speak(toSay, { profile: "customer" });
}
